import { IPaths } from "../../types/types";

export const paths: IPaths = {
  main: "/m",
  dashboard: "/dashboard", // залишаємо для зворотної сумісності
  subscription: "/subscription",
  settings: "/settings",
  settingsProfile: "/settings/profile",
  settingsAdmin: "/settings/admin",
  settingsCompanySettings: "/settings/company-settings",
  settingsIntegrations: "/settings/integrations",
  settingsDeploy: "/settings/deploy",
  settingsAboutUs: "/settings/about-us",
  settingsLegalOffer: "/settings/legal/offer",
  
  users: "/users",
  roles: "/roles",
  permissions: "/permissions",
  tenantList: "/tenant-list/",
  logs: "/logs",
  reports: "/reports",
  products: "/products",
  categories: "/categories",
  clients: "/clients",
  faq: "/faq",
  faqCreate: "/faq/create",
  faqEdit: "/faq/:id/edit",
  changelog: "/changelog",
  changelogCreate: "/changelog/create",
  changelogEdit: "/changelog/:id/edit",
  legal: "/legal",
  clientLegalOffer: "/clients/:companyId/legal-offer",
  clientLegalOfferEditor:
    "/clients/:companyId/legal-offer/:stockOwnerId/:channelId",
  notifications: "/notifications",
  tickets: "/ticket",
  ticketThread: "/ticket/:id",
  feedback: "/feedback",
  feedbackThread: "/feedback/:id",
  billing: "/billing",
  billingPlans: "/billing/plans",
  billingPaymentOptions: "/billing/payment-options",
  billingWallets: "/billing/wallets",
  billingWalletDetail: "/billing/wallets/:id",
  billingSubscriptions: "/billing/subscriptions",
  billingSubscriptionDetail: "/billing/subscriptions/:id",
};
